/**
 * @param   {object} state
 *
 * @returns {string}
 */
const getProfileTimezone = state => state.timezone

/**
 * @param   {object}      state
 *
 * @returns {string|null}
 */
const getProfileHomePage = state => state.landingPagePreferences.library_type

/**
 * Returns the preferred team ID, or null when all teams are selected.
 *
 * @param   {object}      state
 *
 * @returns {number|null}
 */
const getProfileTeam = state => state.landingPagePreferences.team

export default {
  getProfileTimezone,
  getProfileHomePage,
  getProfileTeam
}
